import { PRESUPUESTADOR_SET_FEE } from './constants'

export function setFee(fee) {
    return dispatch => {
        dispatch({
            type: PRESUPUESTADOR_SET_FEE,
            data: { cuotasAfinanciar: fee }
        })
    }
}

export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SET_FEE) {
        return {
            ...state,
            cuotasAfinanciar: action.data.cuotasAfinanciar,
            errorAmount: false
        }
    } else {
        return state
    }
}
